import { request } from '@/utils/request';

export function getDgpNotice() {
  return request({
    url: '/systemConfig/dgp/notice',
    method: 'get',
  });
}
// /systemConfig/newdgp/notice

export function getNewDgpNotice() {
  return request({
    url: '/systemConfig/newdgp/notice',
    method: 'get',
  });
}
